import Banner from '../../elements/Banner';
import wave1 from '../../assets/img/wave1.svg';
import wave2 from '../../assets/img/wave2.svg';
import KinesiologistsFilters from './Utils/KinesiologistsFilters';
import nurse1 from '../../assets/img/home/nurse1.png';
import nurse2 from '../../assets/img/home/nurse2.png';
import CompaniesCarrousel from '../Companies/CompaniesCarrousel';
import BannerSlider from 'elements/BannerSlider';
import { useNavigate } from 'react-router-dom';

import { RiCustomerService2Line } from "react-icons/ri";
import { LiaUserNurseSolid } from "react-icons/lia";
import { RiShieldCrossLine } from "react-icons/ri";
import { HiOutlineHomeModern } from "react-icons/hi2";
import { TfiLocationPin } from "react-icons/tfi";
import { GiCheckMark } from "react-icons/gi";
import { Button } from '@mui/material';
import { Helmet } from 'react-helmet';

const homeSchema = {
    '@context': 'https://schema.org',
    '@graph': [
        {
            '@type': 'FAQPage',
            mainEntity: [
                {
                    '@type': 'Question',
                    name: '¿Qué tipo de tratamientos realizan los kinesiólogos?',
                    acceptedAnswer: { '@type': 'Answer', text: 'Rehabilitación musculoesquelética y traumatológica, neurorehabilitación, kinesiología respiratoria, kinesiología de suelo pélvico, kinesiología geriátrica y kinesiología dermatofuncional, entre otras especialidades.' }
                },
                {
                    '@type': 'Question',
                    name: '¿En qué comunas de Chile hay kinesiólogos disponibles?',
                    acceptedAnswer: { '@type': 'Answer', text: 'Contamos con kinesiólogos en la Región Metropolitana, Valparaíso, Biobío, La Araucanía, O\'Higgins y otras regiones. Usa nuestro buscador para encontrar disponibilidad en tu comuna.' }
                },
                {
                    '@type': 'Question',
                    name: '¿Cómo contacto a un kinesiólogo a domicilio?',
                    acceptedAnswer: { '@type': 'Answer', text: 'Desde el perfil de cada profesional puedes contactarlo directamente por WhatsApp. Solo necesitas crear una cuenta gratuita.' }
                }
            ]
        },
        {
            '@type': 'BreadcrumbList',
            itemListElement: [
                { '@type': 'ListItem', position: 1, name: 'Inicio', item: 'https://buscakine.cl/' },
                { '@type': 'ListItem', position: 2, name: 'Buscador de Kinesiólogos', item: 'https://buscakine.cl/kinesiologos' },
                { '@type': 'ListItem', position: 3, name: 'Preguntas Frecuentes', item: 'https://buscakine.cl/preguntas-frecuentes' }
            ]
        }
    ]
};

const whyUsItems = [
    {
        icon: <RiCustomerService2Line size={24} />,
        title: 'Atención Personalizada',
        subtitle: 'Según Tu Necesidad',
        text: 'Cada paciente recibe un plan de rehabilitación único, diseñado específicamente para su patología y objetivos de recuperación, asegurando un tratamiento kinésico eficaz y centrado en la persona.',
    },
    {
        icon: <LiaUserNurseSolid size={28} />,
        title: 'Kinesiólogos',
        subtitle: 'Especializados & Acreditados',
        text: 'Todos nuestros profesionales validan sus credenciales académicas en su perfil, destacando sus Diplomados y Magísteres. Esto garantiza que te atiendas con un experto real en tu dolencia específica.',
    },
    {
        icon: <RiShieldCrossLine size={24} />,
        title: 'Cuidado Preventivo',
        subtitle: '& Educación',
        text: 'Nuestros kinesiólogos no solo tratan la lesión, sino que también educan al paciente y su familia en el cuidado preventivo para evitar complicaciones.',
    },
    {
        icon: <HiOutlineHomeModern size={24} />,
        title: 'Atención Flexible',
        subtitle: 'En Consulta o a Domicilio',
        text: 'Tú decides cómo atenderte. Nuestra plataforma te permite conectar con especialistas que disponen de consulta establecida o que llevan la rehabilitación a la comodidad de tu hogar, adaptándose a tu preferencia.',
    },
    {
        icon: <TfiLocationPin size={24} />,
        title: 'Red de Profesionales',
        subtitle: 'a lo Largo de Chile',
        text: 'Con cobertura en múltiples comunas, accede a un directorio de kinesiólogos con amplia experiencia clínica en distintas regiones del país, facilitando el acceso a salud de calidad donde sea que estés.',
    },
];

const kineBenefits = [
    'En <b>Buscakine.cl</b>, queremos facilitar el acceso a profesionales como tú, especialistas en kinesiología con diversas áreas de experticia.',
    'Al crear tu perfil, aumentas tu presencia online y brindas a tus pacientes una forma fácil y rápida de acceder a una atención confiable y especializada en tu comuna.',
    'Sé parte de una red colaborativa de kinesiólogos, donde todos compartimos el objetivo de mejorar la calidad de vida de las personas, potenciando la visibilidad y el alcance de cada profesional.',
];

export default function Home(props: any) {
    const navigate = useNavigate();
    return (
    <>
    <Helmet>
        <script type="application/ld+json">{JSON.stringify(homeSchema)}</script>
    </Helmet>


    <div className='header_container'>
        <div className='header_content'>
            <div className='header_title'>
                <h2>Encuentra un Kinesiólogo especializado en todo Chile.</h2>
                <h3>Selecciona tu comuna y agenda tu terapia a domicilio o en consulta.</h3>
            </div>
            <div className='header_search'>
                <KinesiologistsFilters />
            </div>
        </div>
        <div className='header_box'>
            <img src={wave2} alt="" className='waves wave2' />
            <img src={wave1} alt="" className='waves wave1' />
        </div>
    </div>

    <div className='sections_container'>
        <section className='section1'>
            <img src={nurse1} alt='kinesiólogo' />
            <h2>Kinesiólogos especialistas a domicilio</h2>
            <span className='text_w_background'>a lo largo de Chile</span>

            <p className='text_1'>En <b>Buscakine.cl</b> te conectamos con kinesiólogos especialistas en diversas áreas de la rehabilitación, listos para atenderte a domicilio o en su consulta. Contamos con profesionales certificados que se adaptan a tus objetivos terapéuticos y ritmo de recuperación.</p>

            <p className='text_2'>Confía en <span className='highlight_text'>Buscakine.cl</span> para encontrar al profesional que necesitas para tu recuperación, donde y cuando más lo requieras.</p>
        </section>

        <section className='section2'>
            <h2 className='section_title'>¿Por qué elegirnos?</h2>
            <div className='items_container'>
                {whyUsItems.map((item) => (
                    <div className='item_box' key={item.title}>
                        <div className='item_box_header'>
                            <div className='item_box_icon'>{item.icon}</div>
                            <div>
                                <h2>{item.title}</h2>
                                <span>{item.subtitle}</span>
                            </div>
                        </div>
                        <p>{item.text}</p>
                    </div>
                ))}
            </div>
        </section>

        <Banner />

        <BannerSlider section="slider-home" />

        <CompaniesCarrousel />

        <section className='section3'>
            <img src={nurse2} alt='kinesiólogo' />
            <h2>¿Te dedicas a la Kinesiología especializada?</h2>
            <span className='text_w_background'>Ayuda a más personas a encontrarte.</span>

            <div className='section_content'>
                {kineBenefits.map((text) => (
                    <div className='section_list_item' key={text}>
                        <GiCheckMark size={22} color='#00A896' />
                        <p className='text_3' dangerouslySetInnerHTML={{ __html: text }} />
                    </div>
                ))}

                <Button
                    className='register_button'
                    fullWidth
                    variant='contained'
                    onClick={() => navigate('/login')}
                >
                    REGISTRARME
                </Button>
            </div>
        </section>
    </div>


    </>
    )
}
